import {Container, Table} from "react-bootstrap";
import {useEffect, useState} from "react";
import {Tabs, Tab} from "react-bootstrap";
import {getCollection} from "../services/firestoreGetCollection";

export function ClassSchedule({danceGroup}) {
    return (
        <div className="text-center">
            {danceGroup.rooster.length > 0 ? (
                <div className="d-flex flex-column gap-2">
                    {danceGroup.rooster.map((entry, index) => (
                        <div key={index} className="card-modern p-3">
                            <div className="d-flex align-items-center justify-content-center gap-3">
                                <i className="fas fa-calendar-day" style={{ color: 'var(--accent-gold)' }}></i>
                                <span className="font-weight-bold">{entry.dag}:</span>
                                <span>{entry.uren}</span>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="card-modern text-center p-4">
                    <i className="fas fa-calendar-times mb-3" style={{ fontSize: '2rem', color: 'var(--medium-gray)' }}></i>
                    <p className="text-muted mb-0">Geen lessen gepland</p>
                </div>
            )}
        </div>
    );
}

export function ClassInfo({classesArray}) {
    const [key, setKey] = useState('Rooster');
    const [classes, setClasses] = useState([]);
    const [lessen, setLessen] = useState({});
    
    useEffect(() => {
        async function getGroepen() {
            const data = await getCollection("classCategories");
            console.log(data)
            return setClasses(data);
        }

        getGroepen();
    }, [])
    
    useEffect(() => {
        async function getLessen() {
            const data = await getCollection("classes");
            console.log(data);
            return setLessen(data);
        }

        getLessen()
    }, [])
    
    const renderScheduleTable = () => {
        if (!lessen.length || !lessen[0]?.groepen) {
            return (
                <div className="text-center py-5">
                    <div className="card-modern">
                        <i className="fas fa-calendar-times mb-3" style={{ fontSize: '3rem', color: 'var(--medium-gray)' }}></i>
                        <h4 className="text-muted mb-3">Lessenrooster wordt geladen...</h4>
                        <p className="text-muted">Het kan even duren voordat de gegevens beschikbaar zijn.</p>
                    </div>
                </div>
            );
        }

        // Static G Dans data to add to the schedule
        const gDansGroup = {
            groepNaam: "G Dans",
            leeftijd: "Geboortejaren 2019-2013",
            uren: [
                { maandag: "" }, // Maandag - empty
                { dinsdag: "" }, // Dinsdag - empty
                { woensdag: "16u - 17u" }, // Woensdag  
                { donderdag: "" }, // Donderdag - empty
                { vrijdag: "" }, // Vrijdag - empty
                { zaterdag: "" } // Zaterdag - empty
            ]
        };

        // Combine existing groups with G Dans
        const allGroups = [...lessen[0].groepen, gDansGroup];

        return (
            <div className="card-modern p-0 overflow-hidden">
                <div className="table-responsive">
                    <Table className="mb-0 modern-table">
                        <thead className="bg-gradient-purple text-white">
                            <tr>
                                <th className="p-3 border-0">
                                    <i className="fas fa-users me-2"></i>
                                    Groep
                                </th>
                                <th className="p-3 border-0">
                                    <i className="fas fa-calendar-day me-2"></i>
                                    Maandag
                                </th>
                                <th className="p-3 border-0">
                                    <i className="fas fa-calendar-day me-2"></i>
                                    Dinsdag
                                </th>
                                <th className="p-3 border-0">
                                    <i className="fas fa-calendar-day me-2"></i>
                                    Woensdag
                                </th>
                                <th className="p-3 border-0">
                                    <i className="fas fa-calendar-day me-2"></i>
                                    Donderdag
                                </th>
                                <th className="p-3 border-0">
                                    <i className="fas fa-calendar-day me-2"></i>
                                    Vrijdag
                                </th>
                                <th className="p-3 border-0">
                                    <i className="fas fa-calendar-day me-2"></i>
                                    Zaterdag
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {allGroups.map((les, index) => (
                                <tr key={index} className="border-bottom">
                                    <td className="p-3 font-weight-bold" style={{ color: 'var(--primary-purple)' }}>
                                        <div className="d-flex align-items-center">
                                            <div 
                                                className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                                                style={{ 
                                                    width: '40px', 
                                                    height: '40px', 
                                                    background: 'var(--primary-purple-light)',
                                                    color: 'var(--primary-purple)'
                                                }}
                                            >
                                                <i className="fas fa-dance"></i>
                                            </div>
                                            {les.groepNaam}
                                        </div>
                                    </td>
                                    {les.uren.map((timeslot, timeslotIndex) => {
                                        return Object.values(timeslot).map((uur, uurIndex) => (
                                            <td key={`${timeslotIndex}-${uurIndex}`} className="p-3">
                                                {uur && (
                                                    <span 
                                                        className="badge rounded-pill px-3 py-2"
                                                        style={{ 
                                                            background: 'var(--accent-gold)',
                                                            color: 'var(--primary-purple)',
                                                            fontSize: '0.85rem'
                                                        }}
                                                    >
                                                        <i className="fas fa-clock me-1"></i>
                                                        {uur}
                                                    </span>
                                                )}
                                            </td>
                                        ));
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    };
    
    return (
        <Container id="lessen" fluid className="bg-enhanced-purple bg-floating-orbs bg-starfield skewedLeftTop section-padding">
            <div className="skewedLeftTopContent">
                <div className="container-modern">
                    <div className="text-center mb-5 fade-in">
                        <h2 className="font-type heading-lg text-light hoofding">Lessen 2025 - 2026</h2>
                        <p className="text-lg text-light opacity-75">
                            Ontdek ons complete aanbod van danslessen voor alle leeftijden
                        </p>
                    </div>
                    
                    <div className="slide-in-left">
                        <Tabs
                            id="controlled-tab"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-4 nav-tabs-modern"
                            fill
                        >
                            <Tab 
                                eventKey="Rooster" 
                                title={
                                    <span>
                                        <i className="fas fa-calendar-alt me-2"></i>
                                        Lessenrooster
                                    </span>
                                }
                            >
                                <div className="mt-4">
                                    {renderScheduleTable()}
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                    
                    <div className="mt-5 slide-in-right">
                        <div className="row g-4">
                            <div className="col-md-4">
                                <div className="card-modern text-center h-100">
                                    <div className="mb-3">
                                        <i className="fas fa-users" style={{ fontSize: '2.5rem', color: 'var(--primary-purple)' }}></i>
                                    </div>
                                    <h5 className="card-modern-title">Voor alle leeftijden</h5>
                                    <p className="card-modern-body">
                                        Van kleuters tot volwassenen, wij hebben de juiste les voor jou.
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card-modern text-center h-100">
                                    <div className="mb-3">
                                        <i className="fas fa-heart" style={{ fontSize: '2.5rem', color: 'var(--accent-gold)' }}></i>
                                    </div>
                                    <h5 className="card-modern-title">Passie voor dans</h5>
                                    <p className="card-modern-body">
                                        Onze ervaren instructeurs delen hun liefde voor dans met enthousiasme.
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card-modern text-center h-100">
                                    <div className="mb-3">
                                        <i className="fas fa-medal" style={{ fontSize: '2.5rem', color: 'var(--primary-purple)' }}></i>
                                    </div>
                                    <h5 className="card-modern-title">Kwaliteit</h5>
                                    <p className="card-modern-body">
                                        Professionele begeleiding in een gezellige en veilige omgeving.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}



